import { getAuthenticatedAxios } from "../../../utils/api";

const MAX_GUIDANCE_PAPERS = 10;

export const hasUsableAbstract = (abstract) => {
  if (typeof abstract === "string") {
    return Boolean(abstract.trim());
  }

  if (Array.isArray(abstract)) {
    return abstract.some((item) => hasUsableAbstract(item));
  }

  if (abstract && typeof abstract === "object") {
    return Object.values(abstract).some((value) => hasUsableAbstract(value));
  }

  return false;
};

const resolvePaperAbstract = (paper) => paper?.abstract ?? paper?.Abstract ?? "";

export const buildPaperAnalysisGuidancePayload = ({
  searchRunId,
  query,
  language,
  searchMode,
  papers = [],
}) => {
  const normalizedPapers = papers.slice(0, MAX_GUIDANCE_PAPERS).map((paper, index) => ({
    title: paper?.title || paper?.Title || "",
    abstract: resolvePaperAbstract(paper),
    pmid: paper?.pmid || paper?.PMID || paper?.id || null,
    pmcid: paper?.pmcid || paper?.PMCID || null,
    url: paper?.url || paper?.URL || null,
    rank: Number.isFinite(Number(paper?.rank ?? paper?.Rank))
      ? Number(paper?.rank ?? paper?.Rank)
      : index + 1,
    relevance_score: Number.isFinite(Number(paper?.relevance_score))
      ? Number(paper.relevance_score)
      : null,
  }));

  return {
    search_run_id: String(searchRunId || "").trim(),
    query: String(query || "").trim(),
    language: ["en", "ja", "zh"].includes(language) ? language : "en",
    search_mode: searchMode === "basic" ? "basic" : "pro",
    papers: normalizedPapers.filter((paper) => hasUsableAbstract(paper.abstract)),
  };
};

export const requestPaperAnalysisGuidance = async ({
  searchRunId,
  query,
  language,
  searchMode,
  papers,
}) => {
  const payload = buildPaperAnalysisGuidancePayload({
    searchRunId,
    query,
    language,
    searchMode,
    papers,
  });
  if (payload.papers.length === 0) {
    throw new Error("Paper analysis guidance requires at least one usable abstract.");
  }
  if (!payload.search_run_id) {
    throw new Error("Paper analysis guidance requires a search_run_id.");
  }
  const authAxios = getAuthenticatedAxios();
  const response = await authAxios.post("/api/v2/paper-analysis/guidance", payload);
  return response.data;
};

export const getPaperAnalysisGuidance = async ({ searchRunId }) => {
  if (!searchRunId) {
    throw new Error("Missing search_run_id for paper analysis guidance.");
  }

  const authAxios = getAuthenticatedAxios();
  try {
    const response = await authAxios.get(
      `/api/v2/paper-analysis/guidance/${encodeURIComponent(searchRunId)}`,
    );
    return response.data || null;
  } catch (error) {
    if (error?.response?.status === 404) {
      return null;
    }
    throw error;
  }
};
